var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest';
import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
export function fetchUserCampaignData(mnemonicId) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(apiRequest(dropEndpointIds.GET_USER_CAMPAIGN_DATA, { recordId: mnemonicId }));
    });
}
